module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/partner_nos_logo-e1a46b4a78e477d38d3823ada94ab7fb.svg";